import React, { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";
import { ArrowRight } from "lucide-react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message || "Merci !");
      setEmail("");
    } catch (err) {
      toast.error("Adresse invalide.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="py-28 md:py-36 relative overflow-hidden">
      <div className="max-w-[900px] mx-auto px-6 md:px-12 text-center">
        <p className="label-caps text-[color:var(--gold)] mb-6">Le Cercle Douba</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
          Recevez nos <em className="italic text-[color:var(--gold-soft)]">confidences</em> olfactives
        </h2>
        <p className="text-white/50 max-w-xl mx-auto mb-14 font-light">
          Nouveautés en avant-première, coulisses de nos parfumeurs, offres réservées à nos abonnés.
        </p>

        <form onSubmit={submit} className="max-w-lg mx-auto flex items-end gap-4">
          <input
            data-testid="newsletter-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Votre adresse email"
            className="input-line flex-1"
          />
          <button
            data-testid="newsletter-submit-btn"
            type="submit"
            disabled={loading}
            className="pb-3 border-b border-[color:var(--gold)] text-[color:var(--gold)] label-caps flex items-center gap-3 hover:gap-5 transition-all"
          >
            {loading ? "..." : "S'inscrire"} <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
